<template>
  <div class="minimum-amount">
    <div class="question">{{$t('promotion_new.minimum_amount')}}</div>
    <div class="input-group">
      <input step="0.01" type="number" v-model="promotion.minAmount">
      <div class="input-overlay">{{ currencySymbol }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PromotionMinimumAmount",

  props: {
    promotion: Object,
    currencySymbol: String
  }
}
</script>